import 'lazysizes';
import 'picturefill';


(($) => {
  $('document').ready(() => {
    
    
  });
})(jQuery);